import React from 'react';
import { Breakpoint, DialogActions, styled, Typography } from '@mui/material';

import { Button } from '@zendesk/forethought-elements';
import BaseModal from 'src/components/base-modal';

interface ConfirmModalProps {
  actions: {
    actionVariant?: 'danger';
    isDisabled?: boolean;
    isLoading?: boolean;
    onClick: () => void;
    title: string;
  }[];
  description?: React.ReactNode;
  isOpen: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
  title: string;
}

export default function ConfirmModal({
  actions,
  description = '',
  isOpen,
  maxWidth = 'xs',
  onClose,
  title,
}: ConfirmModalProps) {
  return (
    <BaseModal
      headerTitle={<Typography variant='font16Bold'>{title}</Typography>}
      hideCloseButton
      isOpen={isOpen}
      maxWidth={maxWidth}
      onClose={onClose}
    >
      {description && (
        <DescriptionContainer>
          <Typography variant='font14'>{description}</Typography>
        </DescriptionContainer>
      )}
      <DialogActions sx={{ p: 3 }}>
        {actions.map(
          ({ actionVariant, isDisabled, isLoading, onClick, title }, index) => {
            return (
              <Button
                disabled={isDisabled}
                isLoading={isLoading}
                key={index}
                onClick={onClick}
                variant={
                  actionVariant ??
                  (index < actions.length - 1 ? 'ghost' : 'main')
                }
              >
                {title}
              </Button>
            );
          },
        )}
      </DialogActions>
    </BaseModal>
  );
}

const DescriptionContainer = styled('div')`
  margin: 0 24px;
`;
